import actionTypes from '../constants/action-types';

const selection = (state = null, action) => {
  if (action.type !== actionTypes.SET_SELECTION) return state;

  const { selection: sel } = action.payload;

  return {
    anchorNode: sel.anchorNode,
    anchorOffset: sel.anchorOffset,
    focusNode: sel.focusNode,
    focusOffset: sel.focusOffset,
    isCollapsed: sel.isCollapsed,
    rangeCount: sel.rangeCount,
    type: sel.type,
  };
};

export default selection;
